import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import config from "@/config/table";
import columnSetting from './columnSetting';
import { minus } from '@/utils/compute';
// 定义全局时间戳过滤器
import moment from "moment";
import { ElMessage } from 'element-plus';
import { updateSend, updateReceive } from "@/api/order";
// import {sellProduct} from "@/api/model/common";

export default {
  name: 'scTable',
  components: {
    columnSetting
  },
  props: {
    tableName: {
      type: String,
      default: ""
    },
    apiObj: {
      type: Object,
      default: () => {}
    },
    params: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => {}
    },
    height: {
      type: [String, Number],
      default: "100%"
    },
    size: {
      type: String,
      default: "default"
    },
    border: {
      type: Boolean,
      default: true
    },
    stripe: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: config.size
    },
    pageSizes: {
      type: Array,
      default: config.pageSizes
    },
    rowKey: {
      type: String,
      default: ""
    },
    summaryMethod: {
      type: Function,
      default: null
    },
    column: {
      type: Object,
      default: () => {}
    },
    remoteSort: {
      type: Boolean,
      default: false
    },
    remoteFilter: {
      type: Boolean,
      default: false
    },
    remoteSummary: {
      type: Boolean,
      default: false
    },
    hidePagination: {
      type: Boolean,
      default: false
    },
    hideDo: {
      type: Boolean,
      default: false
    },
    hideRefresh: {
      type: Boolean,
      default: false
    },
    hideSetting: {
      type: Boolean,
      default: false
    },
    paginationLayout: {
      type: String,
      default: config.paginationLayout
    }
  },
  watch: {
    //监听从props里拿到值了
    data() {
      this.tableData = this.data;
      this.total = this.tableData.length;
    },
    apiObj() {
      this.tableParams = this.params;
      this.refresh();
    },
    column() {
      this.userColumn = this.column;
      console.log(this.userColumn);
    }
  },
  computed: {
    _height() {
      return Number(this.height) ? Number(this.height) + 'px' : this.height;
    },
    _table_height() {
      return this.hidePagination && this.hideDo ? "100%" : "calc(100% - 50px)";
    }
  },
  data() {
    return {
      scPageSize: this.pageSize,
      isActivat: true,
      emptyText: "暂无数据",
      toggleIndex: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      prop: null,
      order: null,
      loading: false,
      tableHeight: '100%',
      tableParams: this.params,
      userColumn: [],
      customColumnShow: false,
      summary: {},
      config: {
        size: this.size,
        border: this.border,
        stripe: this.stripe
      },
      sellProductList: [],
      sellProductObj: {},
      // 存仓类型
      operateTypeObj: {
        0: '递送',
        1: '存仓',
        2: '海运',
        3: '空运'
      },
      // 包裹类型
      packageTypeObj: {
        0: '包裹',
        1: '文件',
        2: '防水袋'
      },
      // 状态
      statusObj: {
        0: '已预报',
        1: '已取件',
        2: '已录单',
        3: '已分配',
        4: '已出货',
        40: '已删除'
      },
      //状态
      trackStatusObj: {
        0: '已预报',
        1: '已取件',
        2: '已录单',
        3: '已分配',
        4: '已出货',
        5: '转运中',
        6: '已送达',
        7: '已结束',
        8: '已超时',
        9: '扣关',
        10: '地址错误',
        11: '快件丢失',
        12: '退件',
        13: '其它异常'
      },
      // 账单状态
      billStatObj: {
        0: '草稿',
        1: '作废',
        2: '未付',
        3: '已付'
      },
      // 费用类型
      transportFundTypesList: [],
      transportFundTypesObj: {},
      // 费用类型
      problemList: [],
      problemObj: {},
      token: '',
      unitList: [],
      unitObj: {}
    };
  },
  mounted() {
    this.userColumn = this.column;
    this.token = localStorage.getItem('token');
    if (this.userColumn[0].table === 'feeTrail' || this.userColumn[0].table === 'sellPrice') {
      this.getTransportFundTypes();
    }
    if (this.tableName === 'entry') {
      this.getUnit();
    }
    this.getSellProduct();
    this.getProblem();
    //判断是否开启自定义列
    // if(this.column){
    // 	this.getCustomColumn()
    // }else{
    // 	this.userColumn = this.column
    // }
    this.userColumn = this.column;
    //判断是否静态数据
    if (this.apiObj) {
      this.getData();
    } else if (this.data) {
      this.tableData = this.data;
      this.total = this.tableData.length;
    }
  },
  activated() {
    if (!this.isActivat) {
      this.$refs.scTable.doLayout();
    }
  },
  deactivated() {
    this.isActivat = false;
  },
  methods: {
    // 销售产品
    async getSellProduct() {
      const that = this;
      const response = await that.$API.common.sellProduct.get();
      if (response.code === 0) {
        that.sellProductList = response.data;
        that.sellProductList.forEach(obj => {
          that.sellProductObj[obj.id] = obj;
        });
      } else {
        ElMessage({
          message: response.message,
          type: 'error'
        });
      }
    },
    // 运单费用类型
    async getTransportFundTypes() {
      const that = this;
      const response = await that.$API.common.transportFundTypes.get();
      if (response.code === 0) {
        that.transportFundTypesList = response.data;
        that.transportFundTypesList.forEach(item => {
          that.transportFundTypesObj[item.id] = item.name;
        });
      } else {
        ElMessage.error('查询费用类型失败，' + response.message);
      }
    },
    async getUnit() {
      const that = this;
      const response = await that.$API.common.getUnit.get();
      if (response.code === 0) {
        that.unitList = response.data;
        that.unitList.forEach(item => {
          that.unitObj[item.id] = `${item.name_en}(${item.name_cn})`;
        });
      } else {
        ElMessage({
          message: response.message,
          type: 'error'
        });
      }
    },
    //获取列
    async getCustomColumn() {
      const userColumn = await config.columnSettingGet(this.tableName, this.column);
      this.userColumn = userColumn;
    },
    //获取数据
    async getData() {
      this.loading = true;
      localStorage.setItem('currentPage', this.currentPage);
      localStorage.setItem('scPageSize', this.scPageSize);
      var reqData = {
        [config.request.page]: this.currentPage,
        [config.request.size]: this.scPageSize,
        [config.request.prop]: this.prop,
        [config.request.order]: this.order
      };
      if (this.hidePagination) {
        delete reqData[config.request.page];
        delete reqData[config.request.size];
      }
      if (this.tableName === 'list') {
        reqData.operate_type = 0;
      }
      Object.assign(reqData, this.tableParams);
      try {
        var res = await this.apiObj.get(reqData);
      } catch (error) {
        this.loading = false;
        if (error.statusText) {
          this.emptyText = error.statusText;
        } else {
          this.emptyText = '暂无数据';
        }
        return false;
      }
      let response2 = {};
      if (!this.hidePagination) {
        const reqData2 = {
          [config.request.size]: 1
        };
        if (this.tableName === 'list') {
          reqData2.operate_type = 0;
        }
        Object.assign(reqData2, this.tableParams);
        response2 = await this.apiObj.get(reqData2);
      }
      try {
        var response = config.parseData(res);
      } catch (error) {
        console.log('error', error);
        this.loading = false;
        this.emptyText = "数据格式错误";
        return false;
      }
      if (response.code !== config.successCode) {
        this.loading = false;
        this.emptyText = response.msg;
      } else {
        this.emptyText = "暂无数据";
        this.tableData = (response.data || []).filter(x => x.id);
        if (!this.hidePagination) {
          this.total = response2.data[0] || 0;
        }
        this.summary = response.summary || {};
        this.loading = false;
      }
      if (typeof this.tableData[0] !== 'object') {
        this.tableData = this.tableData.splice(1, this.tableData.length);
      }
      this.$refs.scTable.setScrollTop(0);
      this.$emit('dataChange', res, this.tableData);
    },
    //分页点击
    paginationChange() {
      this.getData();
    },
    //条数变化
    pageSizeChange(size) {
      this.scPageSize = size;
      this.getData();
    },
    //刷新数据
    refresh() {
      this.$refs.scTable.clearSelection();
      this.getData();
    },
    //更新数据 合并上一次params
    upData(params, page = 1) {
      this.currentPage = page;
      this.$refs.scTable.clearSelection();
      Object.assign(this.tableParams, params || {});
      this.getData();
    },
    //重载数据 替换params
    reload(params, page = 1) {
      this.currentPage = page;
      this.tableParams = params || {};
      this.$refs.scTable.clearSelection();
      this.$refs.scTable.clearSort();
      this.$refs.scTable.clearFilter();
      this.getData();
    },
    //自定义变化事件
    columnSettingChange(userColumn) {
      this.userColumn = userColumn;
      this.toggleIndex += 1;
    },
    //自定义列保存
    async columnSettingSave(userColumn) {
      this.$refs.columnSetting.isSave = true;
      try {
        await config.columnSettingSave(this.tableName, userColumn);
      } catch (error) {
        ElMessage.error('保存失败');
        this.$refs.columnSetting.isSave = false;
      }
      ElMessage.success('保存成功');
      this.$refs.columnSetting.isSave = false;
    },
    //自定义列重置
    async columnSettingBack() {
      this.$refs.columnSetting.isSave = true;
      try {
        const column = await config.columnSettingReset(this.tableName, this.column);
        this.userColumn = column;
        this.$refs.columnSetting.usercolumn = JSON.parse(JSON.stringify(this.userColumn || []));
      } catch (error) {
        ElMessage.error('重置失败');
        this.$refs.columnSetting.isSave = false;
      }
      this.$refs.columnSetting.isSave = false;
    },
    //排序事件
    sortChange(obj) {
      if (!this.remoteSort) {
        return false;
      }
      if (obj.column && obj.prop) {
        this.prop = obj.prop;
        this.order = obj.order;
      } else {
        this.prop = null;
        this.order = null;
      }
      this.getData();
    },
    //本地过滤
    filterHandler(value, row, column) {
      const property = column.property;
      return row[property] === value;
    },
    //过滤事件
    filterChange(filters) {
      if (!this.remoteFilter) {
        return false;
      }
      Object.keys(filters).forEach(key => {
        filters[key] = filters[key].join(',');
      });
      this.upData(filters);
    },
    //远程合计行处理
    remoteSummaryMethod(param) {
      const {
        columns
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = this.summary[column.property];
        if (values) {
          sums[index] = values;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    configSizeChange() {
      this.$refs.scTable.doLayout();
    },
    //插入行 unshiftRow
    unshiftRow(row) {
      this.tableData.unshift(row);
    },
    //插入行 pushRow
    pushRow(row) {
      this.tableData.push(row);
    },
    //根据key覆盖数据
    updateKey(row, rowKey = this.rowKey) {
      this.tableData.filter(item => item[rowKey] === row[rowKey]).forEach(item => {
        Object.assign(item, row);
      });
    },
    //根据index覆盖数据
    updateIndex(row, index) {
      Object.assign(this.tableData[index], row);
    },
    //根据index删除
    removeIndex(index) {
      this.tableData.splice(index, 1);
    },
    //根据index批量删除
    removeIndexes(indexes = []) {
      indexes.forEach(index => {
        this.tableData.splice(index, 1);
      });
    },
    //根据key删除
    removeKey(key, rowKey = this.rowKey) {
      this.tableData.splice(this.tableData.findIndex(item => item[rowKey] === key), 1);
    },
    //根据keys批量删除
    removeKeys(keys = [], rowKey = this.rowKey) {
      keys.forEach(key => {
        this.tableData.splice(this.tableData.findIndex(item => item[rowKey] === key), 1);
      });
    },
    //原生方法转发
    clearSelection() {
      this.$refs.scTable.clearSelection();
    },
    toggleRowSelection(row, selected) {
      this.$refs.scTable.toggleRowSelection(row, selected);
    },
    toggleAllSelection() {
      this.$refs.scTable.toggleAllSelection();
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.scTable.toggleRowExpansion(row, expanded);
    },
    setCurrentRow(row) {
      this.$refs.scTable.setCurrentRow(row);
    },
    clearSort() {
      this.$refs.scTable.clearSort();
    },
    clearFilter(columnKey) {
      this.$refs.scTable.clearFilter(columnKey);
    },
    doLayout() {
      this.$refs.scTable.doLayout();
    },
    sort(prop, order) {
      this.$refs.scTable.sort(prop, order);
    },
    // 时间格式话
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
    minus(a, b) {
      minus(a, b);
    },
    getProblem() {
      this.problemList = this.$TOOL.data.get('problemList');
      this.problemObj = this.$TOOL.data.get('problemObj');
    },
    async showProblem(row) {
      const res = await this.$API.transport.wayBill.showProblemIssue.get(row.id);
      if (res.code === 0) {
        row.problem = `问题：${this.problemObj[res.data[0].problem_id].name} | 备注：${this.problemObj[res.data[0].problem_id].content}`;
        this.tableData.forEach((item, index) => {
          if (row.id === item.id) {
            console.log(row);
            console.log(index);
            this.updateIndex(row, index);
          }
        });
      } else {
        ElMessage.error('查看问题失败', res.message);
      }
    },
    async clickDefaultAddress(scope) {
      this.isDefault = true;
      const res = await this.$API.common.sendAddress.get();
      if (res.code === 0) {
        const senderAddressList = res.data;
        let defaultSendAddress = {};
        senderAddressList.forEach(item => {
          if (item.is_default === 1 && item.id !== scope.row.id) {
            defaultSendAddress = item;
          }
        });
        if (JSON.stringify(defaultSendAddress) !== "{}") {
          const thisData = {};
          defaultSendAddress.is_default = 0;
          thisData.id = JSON.parse(JSON.stringify(defaultSendAddress)).id;
          delete defaultSendAddress.created_at;
          delete defaultSendAddress.updated_at;
          delete defaultSendAddress.user_id;
          delete defaultSendAddress.id;
          delete defaultSendAddress.type;
          thisData.data = defaultSendAddress;
          const res2 = await updateSend(thisData);
          if (res2.code === 0) {
            this.tableData.forEach((item, index) => {
              if (item.id === thisData.id) {
                this.$nextTick(() => {
                  this.tableData[index].is_default = this.tableData[index].is_default === 1 ? 0 : 1;
                });
              }
            });
            thisData.id = JSON.parse(JSON.stringify(scope.row)).id;
            const changeDefaultAddress = JSON.parse(JSON.stringify(scope.row));
            changeDefaultAddress.is_default = 1;
            delete changeDefaultAddress.created_at;
            delete changeDefaultAddress.updated_at;
            delete changeDefaultAddress.user_id;
            delete changeDefaultAddress.id;
            delete defaultSendAddress.type;
            thisData.data = changeDefaultAddress;
            const res3 = await updateSend(thisData);
            this.isDefault = false;
            if (res3.code === 0) {
              ElMessage.success('操作成功');
              this.$nextTick(() => {
                this.tableData[scope.$index].is_default = this.tableData[scope.$index].is_default === 1 ? 0 : 1;
              });
            } else {
              ElMessage.success('修改默认地址失败，' + res3.message);
            }
          } else {
            this.isDefault = false;
            ElMessage.success('修改当前默认地址失败，' + res2.message);
          }
        } else {
          const thisData = {};
          const changeDefaultAddress = JSON.parse(JSON.stringify(scope.row));
          changeDefaultAddress.is_default = changeDefaultAddress.is_default === 1 ? 0 : 1;
          delete changeDefaultAddress.created_at;
          delete changeDefaultAddress.updated_at;
          delete changeDefaultAddress.user_id;
          delete changeDefaultAddress.id;
          delete changeDefaultAddress.type;
          thisData.id = JSON.parse(JSON.stringify(scope.row)).id;
          thisData.data = changeDefaultAddress;
          const res4 = await updateSend(thisData);
          this.isDefault = false;
          if (res4.code === 0) {
            ElMessage.success('操作成功');
            this.$nextTick(() => {
              this.tableData[scope.$index].is_default = this.tableData[scope.$index].is_default === 1 ? 0 : 1;
            });
          } else {
            ElMessage.success('修改默认地址失败，' + res4.message);
          }
        }
      } else {
        this.isDefault = false;
        ElMessage.error('获取发件地址失败，' + res.message);
      }
    },
    async clickDefaultAddress2(scope) {
      this.isDefault = true;
      const res = await this.$API.common.receiveAddress.get();
      if (res.code === 0) {
        const receiveAddressList = res.data;
        let defaultReceiveAddress = {};
        receiveAddressList.forEach(item => {
          if (item.is_default === 1 && item.id !== scope.row.id) {
            defaultReceiveAddress = item;
          }
        });
        if (JSON.stringify(defaultReceiveAddress) !== "{}") {
          const thisData = {};
          defaultReceiveAddress.is_default = 0;
          thisData.id = JSON.parse(JSON.stringify(defaultReceiveAddress)).id;
          delete defaultReceiveAddress.created_at;
          delete defaultReceiveAddress.updated_at;
          delete defaultReceiveAddress.user_id;
          delete defaultReceiveAddress.id;
          delete defaultReceiveAddress.warehouse_code;
          thisData.data = defaultReceiveAddress;
          const res2 = await updateReceive(thisData);
          if (res2.code === 0) {
            this.tableData.forEach((item, index) => {
              if (item.id === thisData.id) {
                this.$nextTick(() => {
                  this.tableData[index].is_default = this.tableData[index].is_default === 1 ? 0 : 1;
                });
              }
            });
            thisData.id = JSON.parse(JSON.stringify(scope.row)).id;
            const changeDefaultAddress = JSON.parse(JSON.stringify(scope.row));
            changeDefaultAddress.is_default = 1;
            delete changeDefaultAddress.created_at;
            delete changeDefaultAddress.updated_at;
            delete changeDefaultAddress.user_id;
            delete changeDefaultAddress.id;
            thisData.data = changeDefaultAddress;
            const res3 = await updateReceive(thisData);
            this.isDefault = false;
            if (res3.code === 0) {
              ElMessage.success('操作成功');
              this.$nextTick(() => {
                this.tableData[scope.$index].is_default = this.tableData[scope.$index].is_default === 1 ? 0 : 1;
              });
            } else {
              ElMessage.error('修改默认地址失败，' + res3.message);
            }
          } else {
            this.isDefault = false;
            ElMessage.error('修改当前默认地址失败，' + res2.message);
          }
        } else {
          const thisData = {};
          const changeDefaultAddress = JSON.parse(JSON.stringify(scope.row));
          changeDefaultAddress.is_default = changeDefaultAddress.is_default === 1 ? 0 : 1;
          delete changeDefaultAddress.created_at;
          delete changeDefaultAddress.updated_at;
          delete changeDefaultAddress.user_id;
          delete changeDefaultAddress.id;
          thisData.id = JSON.parse(JSON.stringify(scope.row)).id;
          thisData.data = changeDefaultAddress;
          const res4 = await updateReceive(thisData);
          this.isDefault = false;
          if (res4.code === 0) {
            ElMessage.success('操作成功');
            this.$nextTick(() => {
              this.tableData[scope.$index].is_default = this.tableData[scope.$index].is_default === 1 ? 0 : 1;
            });
          } else {
            ElMessage.success('修改默认地址失败，' + res4.message);
          }
        }
      } else {
        this.isDefault = false;
        ElMessage.error('获取发件地址失败，' + res.message);
      }
    }
  }
};